import React from 'react'
import styles from './styles.css'
import contextUrl from '../../Root/contextUrl';

export default class LogoLoading extends React.Component {
  static propTypes = {}

  render() {

    var logo = '/logo.png'
    var context = contextUrl;
    if(context === 'pi.tufirma.digital' || context === 'test.tufirma.digital' || context === 'portalinmobiliario.tufirma.digital' ){
      logo='/logo_pi.png'
    }

    return (
      <div className={styles.container}>
        <img src={logo} className={styles.spinner} alt="" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/LogoLoading/index.js